<template>
  <div class="index-main">
    <div class="swiper-container">
      <div class="index-swiper swiper-wrapper">
        <div class="swiper-slide  slide-item">
          <div class="slide-content">
            <div class="title">
              公司产品&nbsp;&nbsp;/&nbsp;&nbsp;陶瓷纤维类
              <div class="line"></div>
            </div>
            <div v-if="[0].includes(showIndex)" class="content-main2">
              <div class="item animated backInLeft" @click="toUrl('taocixianweimokuai')">
                <img src="/image/pro/taocixianweimokuai.png" alt="">
                <div class="desc">陶瓷纤维模块</div>
              </div>
              <div class="item animated backInUp" @click="toUrl('taocixianweitan')">
                <img src="/image/pro/taocixianweitan.png" alt="">
                <div class="desc">陶瓷纤维毯</div>
              </div>
              <div class="item animated backInRight" @click="toUrl('taocixianweizhan')">
                <img src="/image/pro/taocixianweizhan.png" alt="">
                <div class="desc">陶瓷纤维模毡</div>
              </div>
              <div class="item animated backInLeft" @click="toUrl('taocixianweiban')">
                <img src="/image/pro/taocixianweiban.png" alt="">
                <div class="desc">陶瓷纤维模板</div>
              </div>
              <div class="item animated backInUp" @click="toUrl('taocixianweizhenkong')">
                <img src="/image/pro/taocixianweizhenkong.png" alt="">
                <div class="desc">陶瓷纤维真空成型制品</div>
              </div>
              <div class="item animated backInRight" @click="toUrl('taocixianweikesu')">
                <img src="/image/pro/taocixianweikesu.png" alt="">
                <div class="desc">陶瓷纤维可塑料</div>
              </div>
            </div>

          </div>
        </div>
        <div class="swiper-slide slide-item">
          <div class="slide-content">
            <div class="title">
              公司产品 &nbsp;&nbsp;/&nbsp;&nbsp;陶瓷纤维类
              <div class="line"></div>
            </div>
            <div v-if="showIndex == 1" class="content-main2 p-m-height">
              <div class="item animated backInLeft" @click="toUrl('taocixianweizhi')">
                <img src="/image/pro/taocixianweizhi.png" alt="">
                <div class="desc">陶瓷纤维纸</div>
              </div>
              <div class="item animated backInUp" @click="toUrl('taocixianweifangzhi')">
                <img src="/image/pro/taocixianweifangzhi.png" alt="">
                <div class="desc">陶瓷纤维纺织品</div>
              </div>
              <div class="item animated backInRight" @click="toUrl('taocixianweishizhan')">
                <img src="/image/pro/taocixianweishizhan.png" alt="">
                <div class="desc">陶瓷纤维湿毡</div>
              </div>
              <div class="item animated backInLeft" @click="toUrl('taocixianweimian')">
                <img src="/image/pro/taocixianweimian.png" alt="">
                <div class="desc">陶瓷纤维棉</div>
              </div>
              <!-- 空白填充 -->
              <div class="item animated backInLeft">
              </div>
              <div class="item animated backInLeft">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Add Pagination -->
      <div class="swiper-pagination"></div>
    </div>
    <div class="animate-more">
      <img src="@/assets/image/xiangxiazhanhang.png" alt="">
    </div>
  </div>
</template>
 
<script>
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
import Swiper from 'swiper'
export default {
  // beforeRouteLeave(to, form, next) {
  //   window.removeEventListener('scroll', this.handleScroll, true)
  //   next()
  // },
  data() {
    return {
      showIndex: 0,
    }
  },
  created() {},
  mounted() {
    const that = this
    new Swiper('.swiper-container', {
      // pagination: '.swiper-pagination',
      direction: 'vertical',
      slidesPerView: 1,
      paginationClickable: true,
      spaceBetween: 3,
      // loop: true,
      mousewheelControl: true,
      nextButton: '.animate-more',
      onSlideChangeEnd: function (swiper) {
        that.showIndex = swiper.activeIndex
      },
    })
  },
  methods: {
    toUrl(key) {
      this.$router.push('/detail/index?p=' + key + '&type=taocixianwei')
    },
  },
}
</script>
 
<style lang="scss" scoped>
.swiper-container {
  width: 100%;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
}
.index-swiper {
  .swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;

    /* Center slide text vertically */
  }
}
</style>